"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var React = __importStar(require("react"));

var PropTypes = __importStar(require("prop-types"));

var SafeAsyncComponent_1 = __importDefault(require("./SafeAsyncComponent"));

var videoplayer_api_client_1 = require("@svt/videoplayer-api-client");

var withTheme_1 = __importDefault(require("../utils/withTheme"));

var time_1 = require("../utils/time");

var Img_1 = __importDefault(require("./Img"));

exports.startsShortly = function (startTime, currentTime) {
  if (!currentTime || !startTime) {
    return false;
  }

  return time_1.minutesLeft(new Date(startTime), currentTime) < 1;
};

exports.StartTime = function (_a, _b) {
  var currentTime = _a.currentTime,
      startTime = _a.startTime;
  var theme = _b.theme;

  if (!currentTime || !startTime) {
    return null;
  }

  return withTheme_1["default"](theme, 'live__start-time')(React.createElement("span", null, time_1.formatStartTime(new Date(startTime), currentTime)));
};

exports.StartTime.displayName = 'StartTime';
exports.StartTime.contextTypes = {
  theme: PropTypes.object
};

exports.TimeLeft = function (_a, _b) {
  var currentTime = _a.currentTime,
      startTime = _a.startTime;
  var theme = _b.theme;

  if (!currentTime || !startTime) {
    return null;
  }

  var start = new Date(startTime);

  if (time_1.minutesLeft(start, currentTime) > 10 || exports.startsShortly(startTime, currentTime)) {
    return null;
  }

  return withTheme_1["default"](theme, 'live__time-left')(React.createElement("span", null, time_1.formatTimeLeft(start, new Date(currentTime)), " kvar"));
};

exports.TimeLeft.displayName = 'TimeLeft';
exports.TimeLeft.propTypes = {
  currentTime: PropTypes.instanceOf(Date),
  startTime: PropTypes.string
};
exports.TimeLeft.contextTypes = {
  theme: PropTypes.object
};

var StartUiLive =
/** @class */
function (_super) {
  __extends(StartUiLive, _super);

  function StartUiLive(props) {
    var _this = _super.call(this, props) || this;

    _this.interval = null;
    _this.state = {
      currentTime: null
    };
    return _this;
  }

  StartUiLive.prototype.safeComponentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, _b, _c;

      var _this = this;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            _a = this.setState;
            _b = {};
            _c = Date.bind;
            return [4
            /*yield*/
            , videoplayer_api_client_1.fetchCurrentTime()];

          case 1:
            _a.apply(this, [(_b.currentTime = new (_c.apply(Date, [void 0, _d.sent()]))(), _b), function () {
              _this.interval = window.setInterval(function () {
                if (!_this.state.currentTime) {
                  return null;
                }

                _this.setState({
                  currentTime: time_1.addSeconds(_this.state.currentTime, 1)
                });
              }, 1000);
            }]);

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  StartUiLive.prototype.safeComponentWillUnmount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (this.interval) {
          window.clearInterval(this.interval);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  StartUiLive.prototype.render = function () {
    var currentTime = this.state.currentTime;
    var liveStart = this.props.streamInfo.liveStart;
    return withTheme_1["default"](this.context.theme, 'live')(React.createElement("div", null, withTheme_1["default"](this.context.theme, 'live__left')(React.createElement("div", null, withTheme_1["default"](this.context.theme, 'live__header')(React.createElement("div", null, "S\xE4ndningen startar", exports.startsShortly(liveStart, currentTime) ? ' strax' : '')), withTheme_1["default"](this.context.theme, 'live__divider')(React.createElement("span", null)), React.createElement(exports.StartTime, {
      currentTime: currentTime,
      startTime: liveStart
    }), React.createElement(exports.TimeLeft, {
      currentTime: currentTime,
      startTime: liveStart
    }))), withTheme_1["default"](this.context.theme, 'live__right')(React.createElement("div", null, withTheme_1["default"](this.context.theme, 'live__poster')(React.createElement(Img_1["default"], {
      src: this.props.poster
    }))))));
  };

  StartUiLive.contextTypes = __assign({}, SafeAsyncComponent_1["default"].contextTypes, {
    theme: PropTypes.object
  });
  return StartUiLive;
}(SafeAsyncComponent_1["default"]);

exports["default"] = StartUiLive;